<template>
    <div class="sms-code-container">
        <div class="btn-code" @click="get_code" :class="{ 'in-active': second > 0 }">
            {{ text }}
        </div>

        <popup :show.sync="is_popup_show">
            <div class="ppp">
                <p class="info">完成安全验证，请输入验证码</p>
                <captcha class="captcha" :width="200" :height="65" :outcode.sync="captcha_code"></captcha>
                <p class="again" @click="refresh_code">看不清，换一张</p>
                <input type="text" v-model="form_data.captcha_code" placeholder="请输入验证码" />
                <div class="btn-confirm-code" @click="validate_captcha">确定</div>
            </div>
        </popup>
    </div>

</template>

<script>
import Popup from "@/components/Popup.vue";
import Captcha from "@/components/Captcha.vue";
import {
    SendSms
} from "@/api/index.js"
export default {
    name: "SmsCode",
    props: {
        mobile: {
            type: String,
        },
        scene: {
            type: String,
            default: 'common'
        },
    },
    components: {
        Popup,
        Captcha
    },
    data() {
        return {
            form_data: {
                captcha_code: ''
            },
            captcha_code: '',
            is_valid: false,
            is_popup_show: false,
            interval_id: null,
            second: 0
        }
    },
    computed: {
        text() {
            if (this.second > 0) {
                return `${this.second}S后可重发`
            }

            return '获取验证码'
        },
    },
    methods: {
        validate_captcha() {
            if (this.captcha_code.length === 0) {
                this.$layer.msg(`请输入验证码`)
                return
            }
            if (this.captcha_code !== this.form_data.captcha_code) {
                this.$layer.msg(`验证码错误`)
                return
            }
            this.form_data.captcha_code = ''
            this.is_valid = true
            this.is_popup_show = false
            this.get_code()
        },
        refresh_code() {
            this.captcha_code = String(Math.floor(Math.random() * 9000 + 1000))
        },
        get_code() {
            if (!this.is_valid) {
                this.is_popup_show = true
                return
            }
            if (this.second > 0) {
                return
            }
            if (!this.mobile || this.mobile.length !== 11) {
                this.$layer.msg(`请填写正确的手机号`)
                return
            }

            SendSms({
                mobile: this.mobile,
                scene: this.scene
            }).then(() => {
                this.second = 60
                this.interval_id = setInterval(() => {
                    if (this.second === 0) {
                        clearInterval(this.interval_id)
                    }

                    this.second--
                }, 1000)
            }).catch((res) => {
                this.$layer.msg(res.msg)
            })
        },
    },
    mounted() {
    }
}
</script>

<style scoped lang="scss">
.sms-code-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.btn-code {
    font-size: 14px;
    color: #EE2E47;
    cursor: pointer;

    &.in-active {
        color: #666666;
        cursor: auto;
    }
}

::v-deep .popup-modal {
    .ppp {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;

        .info {
            margin: 20px 0;
            font-size: 14px;
            color: #4d4d4e;
        }

        .captcha {}

        .again {
            width: 100%;
            text-align: center;
            color: #EE2E47;
            font-size: 12px;
            margin: 15px 0;
            cursor: pointer;
        }

        input {
            display: block;
            width: 280px;
            height: 40px;
            line-height: 40px;
            border-radius: 6px;
            background: #EFEFF0;
            outline: none;
            border: none;
            padding: 10px;
        }

        .btn-confirm-code {
            width: 280px;
            height: 40px;
            line-height: 40px;
            margin: 15px 0;
            background: #EE2E47;
            border-radius: 6px;
            text-align: center;
            font-size: 16px;
            color: white;
        }
    }
}
</style>
